// force the logo to load with a data uri string
// tslint:disable-next-line:no-var-requires
export const logo = require('!url-loader!./logo.png');
